var year = (new Date()).getFullYear();
var yr = [];

for (var i = year ; i>=2008; i--){        
    yr[i] = i;
}



export const retentionYears = yr;

export const allMonths = [
    {"id": "01","month": "January"},
    {"id": "02","month": "February"},
    {"id": "03","month": "March"},
    {"id": "04","month": "April"},
    {"id": "05","month": "May"},
    {"id": "06","month": "June"},
    {"id": "07","month": "July"},
    {"id": "08","month": "August"},
    {"id": "09","month": "September"},
    {"id": "10","month": "October"},
    {"id": "11","month": "November"},
    {"id": "12","month": "December"}
    
];



export const zeroPad = (value, length) => {
    //return `${value}`.padStart(length, '0');
    //return `${value}`.slice(length, '0');
    return ("0" +value).slice(-length);
}

var day = [];

for (i = 1 ; i<=31; i++){        
    day[i] = i;
}
export const allDays = day;


export const dateFrom = (day, month, year) => {
    return `${day}/${month}/${year}`;
}

export const dateTo = (day, month, year) => {
    return `${day}/${month}/${year}`;
}


